import {
    Component,
    Input,
    OnInit
} from '@angular/core';

import {
    NgbActiveModal
} from '@ng-bootstrap/ng-bootstrap';

import { AuditService } from '../../audit/audit.service';
import { ExportOrderAuditService } from './export-order-audit.service';
import { OrderService } from '../order.service';

import {
    getSafeProp
} from '../../common/util/';

@Component({
    selector: 'order-audit-report',
    templateUrl: './order-audit-report.component.html'
})
export class OrderAuditReportComponent implements OnInit {
    @Input() orderKey: any;

    order: any;
    auditData: any[] = [];

    loading = false;

    readonly noDataMessage: string = 'No changes.';

    constructor(
        private activeModal: NgbActiveModal,
        private auditService: AuditService,
        private exportOrderAuditService: ExportOrderAuditService,
        private orderService: OrderService
    ) {
    }

    ngOnInit() {
        this.getData();
    }

    private getData(): Promise<void> {

        const p1 = this.orderService.getOrder(this.orderKey)
            .then((data: any) => {
                this.order = data;
            });

        const p2 = this.auditService.getOrderAuditData(this.orderKey)
            .then((response: any) => {
                this.auditData = getSafeProp(response, 'data.results') || [];
            });

        this.loading = true;
        return Promise.all([p1, p2]).then(() => {
            this.loading = false;
        }).catch((error) => {
            this.loading = false;
            throw error;
        });
    }

    onCancel(): void {
        this.activeModal.dismiss();
    }

    exportAudit(): void {
        this.exportOrderAuditService.exportToCsv(
            this.auditData,
        );
    }
}
